export default "__VITE_ASSET__b49d3a9f__"